import {Component, OnInit} from '@angular/core';
import {CrudService} from "@core/shared/services/crud.service";
import {CrudAction} from "@core/shared/models/crud";

@Component({
    selector: 'app-core-page-channel-create',
    templateUrl: './page-channel-create.component.html',
    styleUrls: ['./page-channel-create.component.scss'],
    providers: [
        CrudService
    ],
    standalone: false
})
export class PageChannelCreateComponent implements OnInit {

    constructor(
        private _crudService: CrudService
    ) {}

    ngOnInit() {

        this._crudService.setAction(CrudAction.Create);
    }
}
